/* assets/adore-range.js
   1 Oct 2026, CRO build 4. Colour strip on the flooring range cards (snippets/adore-range-card.liquid).
   - Tapping a colour swaps the card's big photo to that colour and shows its name and price under the strip.
     The page does not change; only the card's "View all colours" button opens the range page.
   - The strip scrolls sideways (swipe on phones). On computers, arrow buttons appear at the ends when there are
     more colours than fit.
   Loaded by sections/adore-range-cards.liquid and sections/adore-range-page.liquid.
   - 2 Oct 2026 (Nas, panel UX): double tap removed. One tap previews a colour; the "View this colour" link under the
     strip opens it. */
(function () {
  if (window.adoreRangeCards) return;
  window.adoreRangeCards = true;

  function pick(btn) {
    var card = btn.closest('[data-arc]');
    if (!card) return;
    var img = card.querySelector('.arc__img');
    if (img) {
      img.classList.add('is-swap');
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        img.srcset = btn.dataset.srcset || '';
        img.src = btn.dataset.src;
        img.alt = btn.dataset.name || '';
        img.classList.toggle('is-rot', (btn.dataset.rot || '').indexOf('1') > -1); // turn it on its side when snippets/adore-range-rot says so (see CSS)
        img.classList.remove('is-swap');
      };
      pre.src = btn.dataset.src;
    }
    [].forEach.call(card.querySelectorAll('.arc__swb'), function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var out = card.querySelector('.arc__pick');
    if (out) {
      out.textContent = '';
      var n = document.createElement('strong'); n.textContent = btn.dataset.name || '';
      var pr = document.createElement('span'); pr.textContent = btn.dataset.price ? ', ' + btn.dataset.price : '';
      out.appendChild(n); out.appendChild(pr);
      // 1 Oct 2026 (Nas): a plain link to the chosen colour. 2 Oct 2026: now the only way to open it (double tap removed).
      if (btn.dataset.url) {
        var a = document.createElement('a'); a.className = 'arc__pick-go'; a.href = btn.dataset.url;
        a.textContent = 'View this colour'; a.setAttribute('aria-label', 'View ' + (btn.dataset.name || 'this colour'));
        out.appendChild(document.createTextNode('. ')); out.appendChild(a);
      }
    }
  }

  function arrows(wrap) {
    var list = wrap.querySelector('.arc__sw');
    var prev = wrap.querySelector('.arc__arr--prev'), next = wrap.querySelector('.arc__arr--next');
    if (!list || !prev || !next) return;
    var max = list.scrollWidth - list.clientWidth;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    prev.hidden = !fine || list.scrollLeft <= 2;
    next.hidden = !fine || list.scrollLeft >= max - 2;
    wrap.classList.toggle('has-more', list.scrollLeft < max - 2);
    wrap.classList.toggle('has-less', list.scrollLeft > 2);
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.arc__swb');
    if (sw) {
      e.preventDefault();
      // 2 Oct 2026 (Nas, panel UX): every tap just previews. The double tap to open (1 Oct) was hidden and easy to
      // trigger by accident; the "View this colour" link does that job now.
      pick(sw); return;
    }
    // 2 Oct 2026 (panel UX): "Show all ranges" on phones, and a brand pick, show every range card
    var more = e.target.closest('[data-ar-more]');
    if (more) { var sec = more.closest('.ar-types'); if (sec) sec.classList.add('is-all'); return; }
    var chip = e.target.closest('.ar-chip');
    if (chip) { var sc = chip.closest('.ar-types'); if (sc) sc.classList.add('is-all'); }
    // 2 Oct 2026 (panel UX): tapping the big photo opens the range page, like the "View all colours" button
    var media = e.target.closest('.arc__media');
    if (media) { var go = media.closest('[data-arc]').querySelector('.arc__btn'); if (go && go.href) window.location.href = go.href; return; }
    var ar = e.target.closest('.arc__arr');
    if (ar) {
      var list = ar.parentNode.querySelector('.arc__sw');
      list.scrollBy({ left: (ar.classList.contains('arc__arr--prev') ? -1 : 1) * list.clientWidth * 0.8, behavior: 'smooth' });
    }
  });

  function init() {
    [].forEach.call(document.querySelectorAll('.arc__swwrap'), function (wrap) {
      if (wrap.dataset.on) return;
      wrap.dataset.on = '1';
      var list = wrap.querySelector('.arc__sw');
      list.addEventListener('scroll', function () { arrows(wrap); }, { passive: true });
      arrows(wrap);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', function () { [].forEach.call(document.querySelectorAll('.arc__swwrap'), arrows); });
  window.addEventListener('load', function () { [].forEach.call(document.querySelectorAll('.arc__swwrap'), arrows); });
})();
